<template>
  <div id="app" :class="grayClass">
    <Header></Header>
    <router-view/>
    <Footer v-if="$route.name != 'searchthird'"></Footer>
    <FooterSearchthird v-if="$route.name == 'searchthird'"></FooterSearchthird>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
    data(){
        return {
            grayClass : ''
        }
    },
    created() {
	    this.$store.state.languageVuex = localStorage.getItem('language') || ((navigator.language == 'zh-CN' || navigator.language == 'en') ? navigator.language : 'zh-CN')
    },
    // watch: {
    //     $route(to, from) {
    //         if (to && (to.name == 'ratingResult' || to.name == 'search') ) {
    //             this.grayClass = ''
    //         } else {
    //             this.grayClass = 'gray'
    //         }
    //     }
    // }
}
</script>

<style scoped>
    .gray{
        -webkit-filter: grayscale(.95);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue